import {
    getSearchData,
    hasFilledDates,
    removeSearchCookieDates,
    triggerSearchQuerySubmittedEdapEvent,
    triggerSearchSubmitEdapEvent
} from './';

function submitForm(tracking, edap, search, form, destination, dates, guests) {
    const {
        actions: {
            setIsSubmitting: setIsFormSubmitting
        },
        events: {
            onSubmit
        }
    } = form;

    const {
        actions: {
            setIsTypeaheadInputFocus: setIsDestinationTypeaheadInputFocus
        },
        selectors: {
            isValid: isDestinationValid
        }
    } = destination;

    const {
        latestValues: {
            startDate,
            endDate
        }
    } = dates;

    if (!isDestinationValid()) {
        setIsDestinationTypeaheadInputFocus(true);

        return;
    }

    setIsFormSubmitting(true);

    if (!hasFilledDates(startDate, endDate)) {
        removeSearchCookieDates();
    }

    triggerSearchSubmitEdapEvent(tracking, edap, search, destination, dates, guests);
    triggerSearchQuerySubmittedEdapEvent(tracking, edap);

    const searchData = getSearchData(search, destination, dates, guests);

    setTimeout(function stopSubmitting() {
        setIsFormSubmitting(false);
    }, 3500);

    onSubmit(searchData);
}

export {
    submitForm
};
